import { render, staticRenderFns } from "./OperationBlock.vue?vue&type=template&id=6076f95b&"
import script from "./OperationBlock.vue?vue&type=script&lang=ts&"
export * from "./OperationBlock.vue?vue&type=script&lang=ts&"
import style0 from "./OperationBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VListItem,VRow})
